import Vue from 'vue';
import ProductQuantity from '@/modules/product/components/ProductQuantity.vue';
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex';
export default Vue.extend({
    components: { ProductQuantity },
    props: {
        product: {
            type: Object,
            default: null,
        },
        isLoading: Boolean,
    },
    data() {
        return {
            quantity: 1,
            wishlistLoading: false,
        };
    },
    computed: {
        ...mapState('authModule', ['isLoggedIn']),
        ...mapState('wishlistModule', ['itemsWishlist', 'loaded', 'loading']),
        ...mapGetters('wishlistModule', ['isOnWishlist']),
        discountPercent() {
            const original = Number(this.product?.old_price);
            const discounted = Number(this.product?.price);
            if (!original || !discounted || discounted >= original)
                return 0;
            return Math.round(((original - discounted) / original) * 100);
        },
    },
    methods: {
        ...mapActions('wishlistModule', ['addToWishList', 'removeWishlistItem']),
        addToCart() {
            console.log('add to cart!');
        },
        formatLargeNumber(value) {
            if (value === null || value === undefined)
                return '0';
            if (value >= 1e9)
                return (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B+';
            if (value >= 1e6)
                return (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M+';
            if (value >= 1e3)
                return (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'k+';
            return value.toString();
        },
        // goToProduct(): void {
        //   this.setCurrentProduct(this.product);
        //   const url = `product/${this.product.slug}`;
        //   console.log(url);
        //   console.log(this.product.category_is_alcohol);
        //   if (this.product.category_is_alcohol) {
        //     if (this.$root.$refs.AlcoholAlert)
        //       (this.$root.$refs.AlcoholAlert as Vue & {
        //         alcoholShowModal: (url: string) => boolean;
        //       }).alcoholShowModal(`/product/${this.product.slug}`);
        //   } else {
        //     window.location.href = '/product/' + this.product.slug;
        //   }
        // },
        // Unified handler that shows the spinner while add/remove runs
        async toggleWishlist(itemUuid) {
            if (this.wishlistLoading || this.loading)
                return; // guard against double-clicks
            this.wishlistLoading = true;
            await this.$nextTick(); // allow DOM to paint spinner before async work
            try {
                if (!this.isOnWishlist(itemUuid)) {
                    const item = { productUuid: itemUuid };
                    // mapActions returns a Promise; await to keep spinner until done
                    await this.addToWishList(item);
                }
                else {
                    const wishlistUuid = this.getWishlistUuidByProductUuid(itemUuid);
                    if (wishlistUuid) {
                        const item = { wishlistUuid };
                        await this.removeWishlistItem(item);
                    }
                }
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error('Wishlist toggle failed:', e);
                // Optional: show a toast here
            }
            finally {
                this.wishlistLoading = false;
            }
        },
        getWishlistUuidByProductUuid(productUuid) {
            const match = this.itemsWishlist.find(item => item?.product?.uuid === productUuid);
            return match ? match.wishlistUuid : null;
        },
        async openAuthModal() {
            await this.$store.commit('wishlistModule/setProductNameToWishlist', this.product.uuid);
            this.$bvModal.show(this.product.uuid);
        },
        ...mapMutations('productModule', ['setCurrentProduct']),
    },
});
